export function renderFileUploadFieldJsxFieldControllerTemplate({
  name,
  fieldContainerClass,
  formLabelWithDescriptionLine,
  escapeAttribute,
  multiple,
  inputClass,
  errorMessageLine
}: {
  name: string
  fieldContainerClass: string
  formLabelWithDescriptionLine: string
  escapeAttribute: string
  multiple: string
  inputClass: string
  errorMessageLine: string
}): string {
  return `        <Controller
          control={form.control}
          name="${name}"
          render={({ field }) => (
            <div className="${fieldContainerClass}">
              ${formLabelWithDescriptionLine}
              <input
                id="${name}"
                type="file"
                accept="${escapeAttribute}"${multiple}
                onChange={(event) => {
                  const selectedFiles = Array.from(event.target.files ?? [])
                  field.onChange(selectedFiles.map((file) => file.name).join(', '))
                }}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
                className="${inputClass}"
              />
${errorMessageLine}
            </div>
          )}
        />`
}
